import React from 'react';
import messages from '../../../messages';
import * as yup from 'yup';
import { updateCompany } from '../../API/company';
import { getSellerData } from '../../API/amazonKeepa';
import { useSnackbarContext } from '../../../contexts/Snackbar';
import { useOnboardingContext } from '../../../contexts/Onboarding';
import { useCompanyContext } from '../../../contexts/Company';
import { Field } from 'formik';
import { TextField } from 'formik-material-ui';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Step from '../BuildingBlocks/Stepper/Step';

const useStyles = makeStyles((theme) => ({
  fieldContainer: { display: 'flex', justifyContent: 'center' },
  field: {
    maxWidth: 500,
  },
}));

export default function SellerId({ setVerifySellerName }) {
  const classes = useStyles();
  const { setLoading } = useOnboardingContext();
  const { business, setBusiness } = useCompanyContext();
  const snackbar = useSnackbarContext();

  async function generateAmzSellerData(sellerId: string) {
    // IF FAIL, FAILS SILENTLY
    let sellerName = null;
    try {
      const seller = await getSellerData(sellerId, false);
      sellerName = seller.sellerName;
    } catch (error) {
      console.log('Error retrieving seller data', error);
    }
    return sellerName;
  }

  async function handleSubmit(values: { sellerId: string }) {
    try {
      setLoading(true);
      await updateCompany({ seller_id: values.sellerId });
      const sellerName = await generateAmzSellerData(values.sellerId);
      setBusiness({
        ...business,
        sellerId: values.sellerId,
        name: sellerName,
      });
      setVerifySellerName(true);
    } catch (error) {
      snackbar.show(messages.general.saveError, 'error');
    }
    setLoading(false);
  }

  return (
    <Step
      initialValues={{ sellerId: business.sellerId || '' }}
      validationSchema={yup.object({
        sellerId: yup
          .string()
          .required('This field is required')
          .test(
            'valid-length',
            'Amazon Seller IDs are between 13-15 characters.',
            (value) =>
              value &&
              (value.length === 13 ||
                value.length === 14 ||
                value.length === 15),
          ),
      })}
      onSubmit={async (values) => {
        await handleSubmit(values);
      }}
      component={() => {
        return (
          <div className={classes.fieldContainer}>
            <Field
              fullWidth
              component={TextField}
              name="sellerId"
              label="Seller ID"
              variant="outlined"
              placeholder="XXXXXXXXXXXXXX"
              className={classes.field}
            />
          </div>
        );
      }}
    />
  );
}
